// This file serves as an entry point for the package
import { sca } from './src/sca'
globalThis.sca = sca
globalThis.sca.prototype = sca.prototype
